import { createContext, useContext } from 'react';

export const SegmentReadOnlyContext = createContext(false);

export const useSegmentReadOnly = () => useContext(SegmentReadOnlyContext);
